import Model from './Model'

export default class OptionModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'options'
  }
}
